import 'moment/locale/zh-cn';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {Provider} from 'mobx-react';
import stores from './stores'

import App from './App';
import registerServiceWorker from './registerServiceWorker';

((doc, win) => {
  const docEl = doc.documentElement;
  const resizeEvt =
    'orientationchange' in window ? 'orientationchange' : 'resize';
  const recalc = () => {
    const { clientWidth } = docEl;
    if (!clientWidth) {
      return;
    }
    if (clientWidth >= 750) {
      docEl.style.fontSize = '100px';
    } else {
      docEl.style.fontSize = `${100 * (clientWidth / 750)}px`;
    }
  };

  if (!doc.addEventListener) {
    return;
  }
  win.addEventListener(resizeEvt, recalc, false);
  doc.addEventListener('DOMContentLoaded', recalc, false);
})(document, window);
ReactDOM.render(
  <Provider {...stores}>
    <App  />
  </Provider>, 
  document.getElementById('root') as HTMLElement);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx